module.exports = __webpack_public_path__ + "img/logo-stripe.f7861b1c.png";